import { ActivityLogEntity } from 'entityTypes/ActivityLog';
import { ReportEntity } from 'entityTypes/Report';
import { IBaseEntity } from 'interfaces/baseEntity';
import { TableSettings } from 'types/TableSettings';

import { INIT_USER_CLIENT_PERMISSIONS } from '@/components/routing/constants/permissions';
import { PermissionStatusEnum } from '@/components/routing/enums/userClientPermissionEnum';
import { MonthOptionEnum } from 'enums/PrismaEnums';
import { ClientEntity } from './Client';
import { LeaseEntity } from './Lease/Lease';
import { PropertyEntity } from './Property/Property';
import { UserClientEntity } from './UserClient';

export interface UserEntity extends IBaseEntity {
  userUuid: string;
  activeClientUuid: string;
  isAdmin: boolean;
  oktaUserId: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  clientLogo: string;
  isAuth: boolean;
  accessToken: string;
  signInRetries: number;
  tableSettings: TableSettings[];

  oktaClientId?: string;
  userLanguage?: string;
  userInitial?: string;
  isFirstSignIn?: boolean;
  selectedItem?: { PROPERTY_ID: string; uuid: string };
  selectedLease?: LeaseEntity;
  selectedProperty?: PropertyEntity;

  report?: ReportEntity;
  userClients: UserClientEntity[];
  clients?: ClientEntity[];
  activityLogs?: ActivityLogEntity[];
  selectedUserClient?: UserClientEntity;
}

export const settingUserModelWithDefaultValues = (): UserEntity => ({
  oktaUserId: '',
  activeClientUuid: '',
  userName: '',
  firstName: '',
  lastName: '',
  userUuid: '',
  email: '',
  accessToken: '',
  oktaClientId: '',
  isAdmin: false,
  tableSettings: [],
  selectedItem: undefined,
  userClients: [],
  clientLogo: '',
  isAuth: false,
  signInRetries: 0,
  selectedUserClient: {
    userClientUuid: '',
    preferredUnitMeas: '',
    preferredCurrencyCode: '',
    securityRole: '',
    monthOption: MonthOptionEnum.numeric,
    timezone: '',
    userLanguage: '',
    locale: '',
    client: {
      clientUuid: '',
      clientId: '',
      clientName: '',
      unitMeasDefault: undefined,
      currencyCodeDefault: undefined,
      clientLogo: '',
      clientStatus: '',
      clientCurrencies: [],
    },
    userClientPermissions: INIT_USER_CLIENT_PERMISSIONS.map((permission) => ({
      ...permission,
      status: PermissionStatusEnum.NONE,
    })),
    currencySymbol: '',
    currency: {
      currencyCode: '',
      currencyName: '',
      currencySymbol: '',
    },
    clientUuid: '',
  },
  createdAt: '',
});
